var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgExplore = function SvgExplore(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    accessibilityRole: "image"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0594 11.9994C10.0594 13.0695 10.9297 13.9397 12 13.9397C13.0703 13.9397 13.9406 13.0695 13.9406 11.9994C13.9406 10.9292 13.0703 10.0591 12 10.0591C10.9297 10.0591 10.0594 10.9292 10.0594 11.9994Z",
    fill: "#037DD6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 22.0001C17.5228 22.0001 22 17.523 22 12.0001C22 6.47727 17.5228 2.00012 12 2.00012C6.47715 2.00012 2 6.47727 2 12.0001C2 17.523 6.47715 22.0001 12 22.0001ZM14.8459 7.0536C15.4411 6.90357 16.0562 7.0736 16.4914 7.50867C16.9265 7.93873 17.0966 8.55383 16.9465 9.14892L15.7211 14.0547C15.5161 14.8798 14.8759 15.5149 14.0556 15.7199L9.14913 16.9451C9.00908 16.9851 8.86404 17.0001 8.724 17.0001C8.27386 17.0001 7.83872 16.8201 7.50862 16.495C7.07349 16.06 6.90344 15.4449 7.05348 14.8498L8.27886 9.94404C8.48392 9.12391 9.11912 8.48381 9.94437 8.27878L14.8459 7.0536Z",
    fill: "#037DD6"
  })));
};
export default SvgExplore;